<template>
  <div class="component-container">
    <button @click.prevent="batchUpdateUnits">Batch Update Units - if you see this, do not click. Tell Michelle.</button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { fieldValue } from './../../firebase/firebase'

export default {
  data() {
    return {
      distUid: '',
      districtUnits: [
 {
   "units": "1ENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "KENG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Adrian Public Schools"
 },
 {
   "units": "KENG",
   "district": "Air Zoo Aerospace & Science Center"
 },
 {
   "units": "KPNG",
   "district": "Air Zoo Aerospace & Science Center"
 },
 {
   "units": "1PNG",
   "district": "Airport Community School District"
 },
 {
   "units": "2PNG",
   "district": "Airport Community School District"
 },
 {
   "units": "3PNG",
   "district": "Airport Community School District"
 },
 {
   "units": "4PNG",
   "district": "Airport Community School District"
 },
 {
   "units": "KPNG",
   "district": "Airport Community School District"
 },
 {
   "units": "1ENG",
   "district": "All Saints Academy"
 },
 {
   "units": "1LNG",
   "district": "All Saints Academy"
 },
 {
   "units": "1PNG",
   "district": "All Saints Academy"
 },
 {
   "units": "2ENG",
   "district": "All Saints Academy"
 },
 {
   "units": "2LNG",
   "district": "All Saints Academy"
 },
 {
   "units": "2PNG",
   "district": "All Saints Academy"
 },
 {
   "units": "3ENG",
   "district": "All Saints Academy"
 },
 {
   "units": "3LNG",
   "district": "All Saints Academy"
 },
 {
   "units": "3PNG",
   "district": "All Saints Academy"
 },
 {
   "units": "4LNG",
   "district": "All Saints Academy"
 },
 {
   "units": "4PNG",
   "district": "All Saints Academy"
 },
 {
   "units": "5ENG",
   "district": "All Saints Academy"
 },
 {
   "units": "5PNG",
   "district": "All Saints Academy"
 },
 {
   "units": "KENG",
   "district": "All Saints Academy"
 },
 {
   "units": "KLNG",
   "district": "All Saints Academy"
 },
 {
   "units": "KPNG",
   "district": "All Saints Academy"
 },
 {
   "units": "1PNG",
   "district": "Allegan Isd"
 },
 {
   "units": "2PNG",
   "district": "Allegan Isd"
 },
 {
   "units": "3PNG",
   "district": "Allegan Isd"
 },
 {
   "units": "4PNG",
   "district": "Allegan Isd"
 },
 {
   "units": "5PNG",
   "district": "Allegan Isd"
 },
 {
   "units": "1ENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "KENG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Allegan Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "KENG",
   "district": "Almont Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Almont Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "4LNG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "4PNG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "5ENG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "5LNG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "5PNG",
   "district": "Assumption of the Blessed Virgin Mary Sch"
 },
 {
   "units": "1ENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "KENG",
   "district": "Athens Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Athens Area Schools"
 },
 {
   "units": "MSENG2",
   "district": "Athens Area Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Athens Area Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Athens Area Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Athens Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Bad Axe Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Baker, Karen"
 },
 {
   "units": "1ENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "KENG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Baldwin Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "1PNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "2ENG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "2PNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "3ENG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "3PNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "4ENG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "4PNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "5PNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "KENG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "KPNG",
   "district": "Bangor Public Schools (Van Buren)"
 },
 {
   "units": "1ENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "1LNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "1PNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "2ENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "2LNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "2PNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "3ENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "3LNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "3PNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "4ENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "4LNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "4PNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "5ENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "5LNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "5PNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "KENG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "KLNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "KPNG",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "MSENG2",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Battle Creek Area Catholic Schools"
 },
 {
   "units": "1ENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "1LNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "1PNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "2ENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "2LNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "2PNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "3ENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "3LNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "3PNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "4ENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "4LNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "4PNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "5ENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "5LNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "5PNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "KENG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "KLNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "KPNG",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "MSENG1",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "MSENG2",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "MSPNG1",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "MSPNG2",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "MSPNG3",
   "district": "Battle Creek Mathematics & Science Center"
 },
 {
   "units": "2ENG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "2LNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "2PNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "4ENG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "4LNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "4PNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "KENG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "KLNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "KPNG",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "MSPNG1",
   "district": "Battle Creek Montessori Academy"
 },
 {
   "units": "1ENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "KENG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "MSENG1",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "MSENG2",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Battle Creek Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "KENG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Bay City Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Beal City Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Bedford Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "1LNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "1PNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "2ENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "2LNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "2PNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "3ENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "3LNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "3PNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "4ENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "4LNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "4PNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "5ENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "5LNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "5PNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "KENG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "KLNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "KPNG",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "MSENG2",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "MSPNG1",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "MSPNG2",
   "district": "Bellevue Comm School District"
 },
 {
   "units": "1PNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "2PNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "3PNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "4PNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "5PNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "KPNG",
   "district": "Bentley Community School District"
 },
 {
   "units": "1ENG",
   "district": "Berkley School District"
 },
 {
   "units": "1LNG",
   "district": "Berkley School District"
 },
 {
   "units": "1PNG",
   "district": "Berkley School District"
 },
 {
   "units": "2ENG",
   "district": "Berkley School District"
 },
 {
   "units": "2LNG",
   "district": "Berkley School District"
 },
 {
   "units": "2PNG",
   "district": "Berkley School District"
 },
 {
   "units": "3ENG",
   "district": "Berkley School District"
 },
 {
   "units": "3LNG",
   "district": "Berkley School District"
 },
 {
   "units": "3PNG",
   "district": "Berkley School District"
 },
 {
   "units": "4ENG",
   "district": "Berkley School District"
 },
 {
   "units": "4LNG",
   "district": "Berkley School District"
 },
 {
   "units": "4PNG",
   "district": "Berkley School District"
 },
 {
   "units": "5ENG",
   "district": "Berkley School District"
 },
 {
   "units": "5LNG",
   "district": "Berkley School District"
 },
 {
   "units": "5PNG",
   "district": "Berkley School District"
 },
 {
   "units": "KENG",
   "district": "Berkley School District"
 },
 {
   "units": "KLNG",
   "district": "Berkley School District"
 },
 {
   "units": "KPNG",
   "district": "Berkley School District"
 },
 {
   "units": "1ENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "KENG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Big Rapids Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "1PNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "2ENG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "2PNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "3ENG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "3PNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "4PNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "5ENG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "5PNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "KENG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "KPNG",
   "district": "Blessed Sacrament School"
 },
 {
   "units": "1ENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "1LNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "1PNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "2ENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "2LNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "2PNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "3ENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "3LNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "3PNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "4ENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "4LNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "4PNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "5ENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "5PNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "KENG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "KLNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "KPNG",
   "district": "Bloomingdale Public School District"
 },
 {
   "units": "1ENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "KENG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Bridgman Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Brown City Comm School District"
 },
 {
   "units": "MSPNG2",
   "district": "Brown City Comm School District"
 },
 {
   "units": "MSPNG3",
   "district": "Brown City Comm School District"
 },
 {
   "units": "1ENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "1LNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "1PNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "2ENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "2LNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "2PNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "3ENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "3LNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "3PNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "4ENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "4LNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "4PNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "5ENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "5LNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "5PNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "KENG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "KLNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "KPNG",
   "district": "Buchanan Community School District"
 },
 {
   "units": "MSPNG1",
   "district": "Buchanan Community School District"
 },
 {
   "units": "MSPNG2",
   "district": "Buchanan Community School District"
 },
 {
   "units": "1ENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "1PNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "2ENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "2PNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "3ENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "3PNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "4ENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "4PNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "5ENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "5PNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "KENG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "KPNG",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "MSENG1",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "MSENG2",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "MSPNG2",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "MSPNG3",
   "district": "Byron Center Christian Sch."
 },
 {
   "units": "1ENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "KENG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Caledonia Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "1LNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "1PNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "2ENG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "2LNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "2PNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "3ENG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "3LNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "3PNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "4ENG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "4LNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "4PNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "KENG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "KLNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "KPNG",
   "district": "Calhoun Christian School"
 },
 {
   "units": "3PNG",
   "district": "Calhoun Isd"
 },
 {
   "units": "4ENG",
   "district": "Calhoun Isd"
 },
 {
   "units": "5PNG",
   "district": "Calhoun Isd"
 },
 {
   "units": "5ENG",
   "district": "Career Academy South Bend"
 },
 {
   "units": "3ENG",
   "district": "Caro Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Caro Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Caro Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Caro Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Caro Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Caro Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Carrollton School District"
 },
 {
   "units": "1LNG",
   "district": "Carrollton School District"
 },
 {
   "units": "1PNG",
   "district": "Carrollton School District"
 },
 {
   "units": "1PNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Caseville Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "KENG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Cass City Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "KENG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Centreville Public Schools"
 },
 {
   "units": "MSENG2",
   "district": "Centreville Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Centreville Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Centreville Public Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Centreville Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "1PNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "2ENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "2PNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "3ENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "3PNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "4ENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "4PNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "5ENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "5PNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "KENG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "KPNG",
   "district": "Chandler Park Academy"
 },
 {
   "units": "1ENG",
   "district": "Chelsea School District"
 },
 {
   "units": "1LNG",
   "district": "Chelsea School District"
 },
 {
   "units": "1PNG",
   "district": "Chelsea School District"
 },
 {
   "units": "2ENG",
   "district": "Chelsea School District"
 },
 {
   "units": "2LNG",
   "district": "Chelsea School District"
 },
 {
   "units": "2PNG",
   "district": "Chelsea School District"
 },
 {
   "units": "3ENG",
   "district": "Chelsea School District"
 },
 {
   "units": "3LNG",
   "district": "Chelsea School District"
 },
 {
   "units": "3PNG",
   "district": "Chelsea School District"
 },
 {
   "units": "4ENG",
   "district": "Chelsea School District"
 },
 {
   "units": "4LNG",
   "district": "Chelsea School District"
 },
 {
   "units": "4PNG",
   "district": "Chelsea School District"
 },
 {
   "units": "5ENG",
   "district": "Chelsea School District"
 },
 {
   "units": "5LNG",
   "district": "Chelsea School District"
 },
 {
   "units": "5PNG",
   "district": "Chelsea School District"
 },
 {
   "units": "KENG",
   "district": "Chelsea School District"
 },
 {
   "units": "KLNG",
   "district": "Chelsea School District"
 },
 {
   "units": "KPNG",
   "district": "Chelsea School District"
 },
 {
   "units": "2ENG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Coldwater Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Columbia School District"
 },
 {
   "units": "3PNG",
   "district": "Columbia School District"
 },
 {
   "units": "4ENG",
   "district": "Columbia School District"
 },
 {
   "units": "4LNG",
   "district": "Columbia School District"
 },
 {
   "units": "4PNG",
   "district": "Columbia School District"
 },
 {
   "units": "5ENG",
   "district": "Columbia School District"
 },
 {
   "units": "5LNG",
   "district": "Columbia School District"
 },
 {
   "units": "5PNG",
   "district": "Columbia School District"
 },
 {
   "units": "1ENG",
   "district": "Concord Community School"
 },
 {
   "units": "2ENG",
   "district": "Concord Community School"
 },
 {
   "units": "2PNG",
   "district": "Concord Community School"
 },
 {
   "units": "3ENG",
   "district": "Concord Community School"
 },
 {
   "units": "4ENG",
   "district": "Concord Community School"
 },
 {
   "units": "5ENG",
   "district": "Concord Community School"
 },
 {
   "units": "1PNG",
   "district": "Concord Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Concord Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Concord Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Concord Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "1LNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "1PNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "2ENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "2LNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "2PNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "3ENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "3PNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "4ENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "4PNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "5ENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "5PNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "KENG",
   "district": "Covenant Christian School"
 },
 {
   "units": "KLNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "KPNG",
   "district": "Covenant Christian School"
 },
 {
   "units": "1ENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "KENG",
   "district": "Covert Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Covert Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Covert Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "1LNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "2ENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "2LNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "3ENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "3LNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "3PNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "4ENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "4LNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "4PNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "5ENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "5LNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "KENG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "KLNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "KPNG",
   "district": "Cross Lutheran School"
 },
 {
   "units": "2PNG",
   "district": "Dansville Agricultural Schools"
 },
 {
   "units": "2PNG",
   "district": "Dansville Schools"
 },
 {
   "units": "5PNG",
   "district": "Dansville Schools"
 },
 {
   "units": "1ENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "1LNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "1PNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "2ENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "2LNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "2PNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "3ENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "3LNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "3PNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "4ENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "4LNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "4PNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "5ENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "5LNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "5PNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "KENG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "KLNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "KPNG",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "MSPNG1",
   "district": "Delton Kellogg School District"
 },
 {
   "units": "1ENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "1LNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "1PNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "2ENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "2LNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "2PNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "3ENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "3LNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "3PNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "4ENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "4LNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "4PNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "5ENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "5LNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "5PNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "KENG",
   "district": "Dutton Christian School"
 },
 {
   "units": "KLNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "KPNG",
   "district": "Dutton Christian School"
 },
 {
   "units": "MSENG2",
   "district": "Dutton Christian School"
 },
 {
   "units": "1ENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "1LNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "1PNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "2ENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "2LNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "2PNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "3ENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "3LNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "3PNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "4ENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "4LNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "4PNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "5ENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "5LNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "5PNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "KENG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "KLNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "KPNG",
   "district": "East Grand Rapids Public Schools"
 },
 {
   "units": "4ENG",
   "district": "East Martin Christian School"
 },
 {
   "units": "MSPNG1",
   "district": "East Martin Christian School"
 },
 {
   "units": "MSPNG3",
   "district": "East Martin Christian School"
 },
 {
   "units": "1ENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "1LNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "1PNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "2ENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "2LNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "2PNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "3ENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "3LNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "3PNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "4ENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "4LNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "4PNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "5ENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "5LNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "5PNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "KENG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "KLNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "KPNG",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "MSENG2",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "MSPNG1",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "MSPNG2",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "MSPNG3",
   "district": "Eastern Upper Peninsula ISD"
 },
 {
   "units": "1ENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "KENG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Eaton Rapids Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Edwardsburg Public Schools"
 },
 {
   "units": "1PNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "2PNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "3ENG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "3LNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "3PNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "4ENG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "4PNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "5ENG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "5PNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "KPNG",
   "district": "El-majj Malik El-shabazz Academy"
 },
 {
   "units": "1PNG",
   "district": "Elkton-Pigeon-Bay Port-Laker Schools"
 },
 {
   "units": "2PNG",
   "district": "Elkton-Pigeon-Bay Port-Laker Schools"
 },
 {
   "units": "5PNG",
   "district": "Elkton-Pigeon-Bay Port-Laker Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Elkton-Pigeon-Bay Port-Laker Schools"
 },
 {
   "units": "1ENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "1PNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "2ENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "2PNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "3ENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "3PNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "4ENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "4PNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "5ENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "5PNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "KENG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "KPNG",
   "district": "Engadine Consolidated Schools"
 },
 {
   "units": "1ENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "1LNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "1PNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "2ENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "2LNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "2PNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "3ENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "3LNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "3PNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "4ENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "4LNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "4PNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "5ENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "5LNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "5PNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "KENG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "KLNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "KPNG",
   "district": "Essexville Hampton School District"
 },
 {
   "units": "1PNG",
   "district": "Farmington Public School District"
 },
 {
   "units": "2PNG",
   "district": "Farmington Public School District"
 },
 {
   "units": "3PNG",
   "district": "Farmington Public School District"
 },
 {
   "units": "4ENG",
   "district": "Farmington Public School District"
 },
 {
   "units": "5PNG",
   "district": "Farmington Public School District"
 },
 {
   "units": "KPNG",
   "district": "Farmington Public School District"
 },
 {
   "units": "1PNG",
   "district": "Fennville Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Ferndale Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Fitzgerald Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "KENG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Forest Hills Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "KENG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Fowlerville Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "KENG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Fraser Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Freeland Comm School District"
 },
 {
   "units": "4PNG",
   "district": "Freeland Comm School District"
 },
 {
   "units": "5LNG",
   "district": "Freeland Comm School District"
 },
 {
   "units": "5PNG",
   "district": "Freeland Comm School District"
 },
 {
   "units": "1ENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "1PNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "2ENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "2PNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "3ENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "3PNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "4ENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "4PNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "5ENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "5PNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "KENG",
   "district": "Fremont Christian School"
 },
 {
   "units": "KPNG",
   "district": "Fremont Christian School"
 },
 {
   "units": "2ENG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Godwin Heights Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "1LNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "1PNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "2ENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "2LNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "2PNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "3ENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "3LNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "3PNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "4ENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "4LNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "4PNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "5ENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "5LNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "5PNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "KENG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "KLNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "KPNG",
   "district": "Grand Haven Christian School"
 },
 {
   "units": "1ENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "KENG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Grand Ledge Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "1LNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "1PNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "2ENG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "2LNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "2PNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "3ENG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "3LNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "3PNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "4ENG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "4LNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "4PNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "KENG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "KLNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "KPNG",
   "district": "Grand Rapids Christian School"
 },
 {
   "units": "4ENG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Greenville Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Grosse Pointe Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "KENG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Gull Lake Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "1LNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "1PNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "2ENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "2LNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "2PNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "3ENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "3LNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "3PNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "4ENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "4LNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "4PNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "5ENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "5LNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "5PNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "KENG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "KLNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "KPNG",
   "district": "Hanover Horton Schools"
 },
 {
   "units": "1ENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "KENG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Harbor Beach Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "KENG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "MSENG2",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Harper Creek Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Hart Public School District"
 },
 {
   "units": "1LNG",
   "district": "Hart Public School District"
 },
 {
   "units": "1PNG",
   "district": "Hart Public School District"
 },
 {
   "units": "2ENG",
   "district": "Hart Public School District"
 },
 {
   "units": "2LNG",
   "district": "Hart Public School District"
 },
 {
   "units": "2PNG",
   "district": "Hart Public School District"
 },
 {
   "units": "3ENG",
   "district": "Hart Public School District"
 },
 {
   "units": "3LNG",
   "district": "Hart Public School District"
 },
 {
   "units": "3PNG",
   "district": "Hart Public School District"
 },
 {
   "units": "4ENG",
   "district": "Hart Public School District"
 },
 {
   "units": "4LNG",
   "district": "Hart Public School District"
 },
 {
   "units": "4PNG",
   "district": "Hart Public School District"
 },
 {
   "units": "5ENG",
   "district": "Hart Public School District"
 },
 {
   "units": "5LNG",
   "district": "Hart Public School District"
 },
 {
   "units": "5PNG",
   "district": "Hart Public School District"
 },
 {
   "units": "KENG",
   "district": "Hart Public School District"
 },
 {
   "units": "KLNG",
   "district": "Hart Public School District"
 },
 {
   "units": "KPNG",
   "district": "Hart Public School District"
 },
 {
   "units": "1ENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "1LNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "1PNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "2ENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "2LNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "2PNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "3ENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "3LNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "3PNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "4ENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "4LNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "5ENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "5LNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "5PNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "KENG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "KLNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "KPNG",
   "district": "Hemlock Public School District"
 },
 {
   "units": "3ENG",
   "district": "Hesperia Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Hesperia Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "KENG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Hillsdale Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "KENG",
   "district": "Holland Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Holland Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Holly Area School District"
 },
 {
   "units": "1LNG",
   "district": "Holly Area School District"
 },
 {
   "units": "1PNG",
   "district": "Holly Area School District"
 },
 {
   "units": "2ENG",
   "district": "Holly Area School District"
 },
 {
   "units": "2LNG",
   "district": "Holly Area School District"
 },
 {
   "units": "2PNG",
   "district": "Holly Area School District"
 },
 {
   "units": "3ENG",
   "district": "Holly Area School District"
 },
 {
   "units": "3LNG",
   "district": "Holly Area School District"
 },
 {
   "units": "3PNG",
   "district": "Holly Area School District"
 },
 {
   "units": "4ENG",
   "district": "Holly Area School District"
 },
 {
   "units": "4LNG",
   "district": "Holly Area School District"
 },
 {
   "units": "4PNG",
   "district": "Holly Area School District"
 },
 {
   "units": "5ENG",
   "district": "Holly Area School District"
 },
 {
   "units": "5LNG",
   "district": "Holly Area School District"
 },
 {
   "units": "5PNG",
   "district": "Holly Area School District"
 },
 {
   "units": "KENG",
   "district": "Holly Area School District"
 },
 {
   "units": "KLNG",
   "district": "Holly Area School District"
 },
 {
   "units": "KPNG",
   "district": "Holly Area School District"
 },
 {
   "units": "1ENG",
   "district": "Holt Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Holt Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Holt Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Holt Public Schools"
 },
 {
   "units": "KENG",
   "district": "Holt Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Holt Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Holt Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "KENG",
   "district": "Holton Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Holton Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "KENG",
   "district": "Homer Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Homer Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "KENG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Hopkins Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Howell Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "KENG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Hudson Area Schools"
 },
 {
   "units": "1ENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "1LNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "1PNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "2ENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "2LNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "2PNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "3ENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "3LNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "3PNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "4ENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "4LNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "4PNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "5ENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "5LNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "5PNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "KENG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "KLNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "KPNG",
   "district": "Hudsonville Christian School"
 },
 {
   "units": "1PNG",
   "district": "Innocademy Allegan"
 },
 {
   "units": "2PNG",
   "district": "Innocademy Allegan"
 },
 {
   "units": "3PNG",
   "district": "Innocademy Allegan"
 },
 {
   "units": "5PNG",
   "district": "Innocademy Allegan"
 },
 {
   "units": "KPNG",
   "district": "Innocademy Allegan"
 },
 {
   "units": "3PNG",
   "district": "Island City Academy"
 },
 {
   "units": "4PNG",
   "district": "Island City Academy"
 },
 {
   "units": "1PNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Jackson Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "2PNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "3PNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "4PNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "5PNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "KPNG",
   "district": "Joy Preparatory Academy"
 },
 {
   "units": "1ENG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "2PNG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "3LNG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "3PNG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "4ENG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "5PNG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "KLNG",
   "district": "Kalamazoo Public School District"
 },
 {
   "units": "MSPNG1",
   "district": "Kent City Community Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Kent City Community Schools"
 },
 {
   "units": "1PNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "2PNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "3PNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "4PNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "5PNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "KPNG",
   "district": "L'Anse Creuse Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "1LNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "1PNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "2ENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "2LNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "2PNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "3ENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "3LNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "3PNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "4ENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "4LNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "4PNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "5ENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "5LNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "5PNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "KENG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "KLNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "KPNG",
   "district": "Laingsburg Community School District"
 },
 {
   "units": "1ENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "1LNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "1PNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "2ENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "2LNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "2PNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "3ENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "3PNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "4ENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "4LNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "4PNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "5ENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "5LNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "5PNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "KENG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "KLNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "KPNG",
   "district": "Lake Fenton Schools"
 },
 {
   "units": "3LNG",
   "district": "Lake Superior State University"
 },
 {
   "units": "4LNG",
   "district": "Lake Superior State University"
 },
 {
   "units": "5LNG",
   "district": "Lake Superior State University"
 },
 {
   "units": "1LNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "1PNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "2LNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "2PNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "3LNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "4LNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "4PNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "5LNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "KLNG",
   "district": "Lakeview Community Schools (Montcalm)"
 },
 {
   "units": "1ENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "1LNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "1PNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "2ENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "2LNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "2PNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "3ENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "3LNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "3PNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "4ENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "4LNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "4PNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "5ENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "5LNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "5PNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "KENG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "KLNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "KPNG",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "MSPNG1",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "MSPNG2",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "MSPNG3",
   "district": "Lakeview School District (calhoun)"
 },
 {
   "units": "5PNG",
   "district": "Lawton Community School District"
 },
 {
   "units": "1ENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "1PNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "2ENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "2PNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "3ENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "4ENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "4LNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "4PNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "5ENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "5PNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "KENG",
   "district": "Legacy Christian School"
 },
 {
   "units": "KLNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "KPNG",
   "district": "Legacy Christian School"
 },
 {
   "units": "1ENG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "KENG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Les Cheneaux Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "1LNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "1PNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "2ENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "2LNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "2PNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "3ENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "3LNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "3PNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "4ENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "4LNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "4PNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "5ENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "5LNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "5PNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "KENG",
   "district": "Lowell Area School District"
 },
 {
   "units": "KLNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "KPNG",
   "district": "Lowell Area School District"
 },
 {
   "units": "1ENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "1LNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "1PNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "2ENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "2LNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "2PNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "3ENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "3LNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "3PNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "4ENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "4LNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "4PNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "5ENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "5LNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "5PNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "KENG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "KLNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "KPNG",
   "district": "Ludington Area Catholic School"
 },
 {
   "units": "1ENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "1LNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "1PNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "2ENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "2LNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "2PNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "3ENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "3LNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "3PNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "4ENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "4LNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "4PNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "5ENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "5LNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "5PNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "KENG",
   "district": "Ludington Area School District"
 },
 {
   "units": "KLNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "KPNG",
   "district": "Ludington Area School District"
 },
 {
   "units": "3PNG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Manistee Area Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "1LNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "1PNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "2ENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "2LNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "2PNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "3ENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "3LNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "3PNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "4ENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "4LNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "4PNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "5ENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "5LNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "5PNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "KENG",
   "district": "Maple Valley School District"
 },
 {
   "units": "KLNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "KPNG",
   "district": "Maple Valley School District"
 },
 {
   "units": "MSENG2",
   "district": "Maple Valley School District"
 },
 {
   "units": "MSPNG1",
   "district": "Maple Valley School District"
 },
 {
   "units": "MSPNG2",
   "district": "Maple Valley School District"
 },
 {
   "units": "MSPNG3",
   "district": "Maple Valley School District"
 },
 {
   "units": "1ENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "1LNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "1PNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "2ENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "2LNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "2PNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "3ENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "3LNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "3PNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "4ENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "4LNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "4PNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "5ENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "5LNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "5PNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "KENG",
   "district": "Mar Lee School District"
 },
 {
   "units": "KLNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "KPNG",
   "district": "Mar Lee School District"
 },
 {
   "units": "3ENG",
   "district": "Marlette Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Marlette Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Marshall Academy"
 },
 {
   "units": "1LNG",
   "district": "Marshall Academy"
 },
 {
   "units": "1PNG",
   "district": "Marshall Academy"
 },
 {
   "units": "2ENG",
   "district": "Marshall Academy"
 },
 {
   "units": "2LNG",
   "district": "Marshall Academy"
 },
 {
   "units": "2PNG",
   "district": "Marshall Academy"
 },
 {
   "units": "3ENG",
   "district": "Marshall Academy"
 },
 {
   "units": "3LNG",
   "district": "Marshall Academy"
 },
 {
   "units": "3PNG",
   "district": "Marshall Academy"
 },
 {
   "units": "4ENG",
   "district": "Marshall Academy"
 },
 {
   "units": "4LNG",
   "district": "Marshall Academy"
 },
 {
   "units": "4PNG",
   "district": "Marshall Academy"
 },
 {
   "units": "5ENG",
   "district": "Marshall Academy"
 },
 {
   "units": "5LNG",
   "district": "Marshall Academy"
 },
 {
   "units": "5PNG",
   "district": "Marshall Academy"
 },
 {
   "units": "KENG",
   "district": "Marshall Academy"
 },
 {
   "units": "KLNG",
   "district": "Marshall Academy"
 },
 {
   "units": "KPNG",
   "district": "Marshall Academy"
 },
 {
   "units": "1ENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "KENG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Marshall Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "KENG",
   "district": "Martin Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Martin Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Martin Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "1LNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "1PNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "2ENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "2LNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "2PNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "3ENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "3LNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "3PNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "4ENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "4LNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "4PNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "5ENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "5LNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "5PNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "KENG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "KLNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "KPNG",
   "district": "Mason County Central School Dist"
 },
 {
   "units": "1ENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "1LNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "1PNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "2ENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "2LNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "2PNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "3ENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "3LNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "3PNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "4ENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "4LNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "4PNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "5ENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "5LNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "5PNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "KENG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "KLNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "KPNG",
   "district": "Mason County Eastern School Dist"
 },
 {
   "units": "1PNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Mason Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Mason Public Schools (Ingham)"
 },
 {
   "units": "3PNG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "4ENG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "4PNG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "5ENG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "5LNG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "5PNG",
   "district": "Mattawan Consolidated School District"
 },
 {
   "units": "1ENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "1LNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "1PNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "2ENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "2LNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "2PNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "3ENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "3LNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "3PNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "4ENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "4LNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "4PNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "5ENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "5LNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "5PNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "KENG",
   "district": "Mayville Community School District"
 },
 {
   "units": "KLNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "KPNG",
   "district": "Mayville Community School District"
 },
 {
   "units": "1ENG",
   "district": "Mendon Community School District"
 },
 {
   "units": "1PNG",
   "district": "Mendon Community School District"
 },
 {
   "units": "2ENG",
   "district": "Mendon Community School District"
 },
 {
   "units": "2PNG",
   "district": "Mendon Community School District"
 },
 {
   "units": "3ENG",
   "district": "Mendon Community School District"
 },
 {
   "units": "3PNG",
   "district": "Mendon Community School District"
 },
 {
   "units": "4ENG",
   "district": "Mendon Community School District"
 },
 {
   "units": "4PNG",
   "district": "Mendon Community School District"
 },
 {
   "units": "5ENG",
   "district": "Mendon Community School District"
 },
 {
   "units": "5PNG",
   "district": "Mendon Community School District"
 },
 {
   "units": "1PNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Menominee Area Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Midland Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Midland Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Midland Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "KENG",
   "district": "Milan Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Milan Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Moline Christian School"
 },
 {
   "units": "2ENG",
   "district": "Moline Christian School"
 },
 {
   "units": "2LNG",
   "district": "Moline Christian School"
 },
 {
   "units": "2PNG",
   "district": "Moline Christian School"
 },
 {
   "units": "3LNG",
   "district": "Moline Christian School"
 },
 {
   "units": "3PNG",
   "district": "Moline Christian School"
 },
 {
   "units": "4ENG",
   "district": "Moline Christian School"
 },
 {
   "units": "4LNG",
   "district": "Moline Christian School"
 },
 {
   "units": "4PNG",
   "district": "Moline Christian School"
 },
 {
   "units": "5ENG",
   "district": "Moline Christian School"
 },
 {
   "units": "5LNG",
   "district": "Moline Christian School"
 },
 {
   "units": "5PNG",
   "district": "Moline Christian School"
 },
 {
   "units": "KPNG",
   "district": "Moline Christian School"
 },
 {
   "units": "MSPNG1",
   "district": "Moline Christian School"
 },
 {
   "units": "MSPNG2",
   "district": "Moline Christian School"
 },
 {
   "units": "MSPNG3",
   "district": "Moline Christian School"
 },
 {
   "units": "1PNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "2PNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "3PNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "4PNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "5PNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "KPNG",
   "district": "Mona Shores School District"
 },
 {
   "units": "1ENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "KENG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Montague Area Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Montrose Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "1LNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "1PNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "2ENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "2LNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "2PNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "3ENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "3LNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "3PNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "4ENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "4LNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "4PNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "5ENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "5LNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "5PNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "KENG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "KLNG",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "MSENG2",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Mt Morris Consolidated Schools"
 },
 {
   "units": "4ENG",
   "district": "Muskegon Area Intermed. School Dist."
 },
 {
   "units": "1ENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "1LNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "1PNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "2ENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "2LNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "2PNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "3ENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "3LNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "3PNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "4ENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "4LNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "4PNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "5ENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "5LNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "5PNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "KENG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "KLNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "KPNG",
   "district": "Muskegon Christian School"
 },
 {
   "units": "1ENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "KENG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Muskegon Public Schools"
 },
 {
   "units": "1ENG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "1LNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "1PNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "2ENG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "2LNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "2PNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "3ENG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "3LNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "3PNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "4ENG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "4LNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "4PNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "5ENG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "5LNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "5PNG",
   "district": "New Buffalo Area School District"
 },
 {
   "units": "1PNG",
   "district": "New Era Christian"
 },
 {
   "units": "3PNG",
   "district": "New Era Christian"
 },
 {
   "units": "KPNG",
   "district": "New Era Christian"
 },
 {
   "units": "3PNG",
   "district": "North Muskegon Public Schs."
 },
 {
   "units": "4PNG",
   "district": "North Muskegon Public Schs."
 },
 {
   "units": "5PNG",
   "district": "North Muskegon Public Schs."
 },
 {
   "units": "KPNG",
   "district": "North Muskegon Public Schs."
 },
 {
   "units": "1ENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "1LNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "1PNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "2ENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "2LNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "2PNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "3ENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "3LNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "3PNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "4ENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "4LNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "4PNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "5ENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "5LNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "5PNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "KENG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "KLNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "KPNG",
   "district": "NorthPointe Christian"
 },
 {
   "units": "1ENG",
   "district": "Northport Public School District"
 },
 {
   "units": "1PNG",
   "district": "Northport Public School District"
 },
 {
   "units": "2ENG",
   "district": "Northport Public School District"
 },
 {
   "units": "2PNG",
   "district": "Northport Public School District"
 },
 {
   "units": "3ENG",
   "district": "Northport Public School District"
 },
 {
   "units": "3PNG",
   "district": "Northport Public School District"
 },
 {
   "units": "4ENG",
   "district": "Northport Public School District"
 },
 {
   "units": "4PNG",
   "district": "Northport Public School District"
 },
 {
   "units": "5ENG",
   "district": "Northport Public School District"
 },
 {
   "units": "5PNG",
   "district": "Northport Public School District"
 },
 {
   "units": "KENG",
   "district": "Northport Public School District"
 },
 {
   "units": "KPNG",
   "district": "Northport Public School District"
 },
 {
   "units": "2PNG",
   "district": "Oakland University"
 },
 {
   "units": "KENG",
   "district": "Oakland University"
 },
 {
   "units": "4ENG",
   "district": "Oakridge Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Oakridge Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Oakridge Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "KENG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Olivet Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Orchard View School District"
 },
 {
   "units": "2PNG",
   "district": "Orchard View School District"
 },
 {
   "units": "3PNG",
   "district": "Orchard View School District"
 },
 {
   "units": "4PNG",
   "district": "Orchard View School District"
 },
 {
   "units": "5PNG",
   "district": "Orchard View School District"
 },
 {
   "units": "KPNG",
   "district": "Orchard View School District"
 },
 {
   "units": "2ENG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Otsego Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "1LNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "1PNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "2ENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "2LNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "2PNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "3ENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "3LNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "3PNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "4ENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "4LNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "4PNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "5ENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "5LNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "5PNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "KENG",
   "district": "Oxford Community School District"
 },
 {
   "units": "KLNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "KPNG",
   "district": "Oxford Community School District"
 },
 {
   "units": "1ENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "1LNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "1PNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "2ENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "2LNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "2PNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "3ENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "3LNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "3PNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "4ENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "4LNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "4PNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "5ENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "5LNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "5PNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "KENG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "KLNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "KPNG",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "MSENG1",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "MSENG2",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "MSPNG1",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "MSPNG2",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "MSPNG3",
   "district": "Park Forest - Chicago Heights SD 163"
 },
 {
   "units": "1ENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "1LNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "1PNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "2ENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "2LNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "2PNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "3ENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "3LNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "3PNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "4ENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "4LNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "4PNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "5ENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "5LNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "5PNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "KENG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "KLNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "KPNG",
   "district": "Peace Lutheran School"
 },
 {
   "units": "2ENG",
   "district": "Peck Community School District"
 },
 {
   "units": "3ENG",
   "district": "Peck Community School District"
 },
 {
   "units": "4ENG",
   "district": "Peck Community School District"
 },
 {
   "units": "1ENG",
   "district": "Pennfield School District"
 },
 {
   "units": "1LNG",
   "district": "Pennfield School District"
 },
 {
   "units": "1PNG",
   "district": "Pennfield School District"
 },
 {
   "units": "2ENG",
   "district": "Pennfield School District"
 },
 {
   "units": "2LNG",
   "district": "Pennfield School District"
 },
 {
   "units": "2PNG",
   "district": "Pennfield School District"
 },
 {
   "units": "3ENG",
   "district": "Pennfield School District"
 },
 {
   "units": "3LNG",
   "district": "Pennfield School District"
 },
 {
   "units": "3PNG",
   "district": "Pennfield School District"
 },
 {
   "units": "4ENG",
   "district": "Pennfield School District"
 },
 {
   "units": "4LNG",
   "district": "Pennfield School District"
 },
 {
   "units": "4PNG",
   "district": "Pennfield School District"
 },
 {
   "units": "5ENG",
   "district": "Pennfield School District"
 },
 {
   "units": "5LNG",
   "district": "Pennfield School District"
 },
 {
   "units": "5PNG",
   "district": "Pennfield School District"
 },
 {
   "units": "KENG",
   "district": "Pennfield School District"
 },
 {
   "units": "KLNG",
   "district": "Pennfield School District"
 },
 {
   "units": "KPNG",
   "district": "Pennfield School District"
 },
 {
   "units": "MSENG2",
   "district": "Pennfield School District"
 },
 {
   "units": "MSPNG1",
   "district": "Pennfield School District"
 },
 {
   "units": "MSPNG2",
   "district": "Pennfield School District"
 },
 {
   "units": "MSPNG3",
   "district": "Pennfield School District"
 },
 {
   "units": "1ENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "1LNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "1PNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "2ENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "2LNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "2PNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "3ENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "3LNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "3PNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "4ENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "4LNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "4PNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "5ENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "5LNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "5PNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "KENG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "KLNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "KPNG",
   "district": "Pentwater Public School District"
 },
 {
   "units": "MSPNG1",
   "district": "Pentwater Public School District"
 },
 {
   "units": "1ENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "KENG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Pickford Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "KENG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Pinconning Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Plainwell Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Portland Public School District"
 },
 {
   "units": "1LNG",
   "district": "Portland Public School District"
 },
 {
   "units": "1PNG",
   "district": "Portland Public School District"
 },
 {
   "units": "2ENG",
   "district": "Portland Public School District"
 },
 {
   "units": "2LNG",
   "district": "Portland Public School District"
 },
 {
   "units": "2PNG",
   "district": "Portland Public School District"
 },
 {
   "units": "3ENG",
   "district": "Portland Public School District"
 },
 {
   "units": "3LNG",
   "district": "Portland Public School District"
 },
 {
   "units": "3PNG",
   "district": "Portland Public School District"
 },
 {
   "units": "4ENG",
   "district": "Portland Public School District"
 },
 {
   "units": "4LNG",
   "district": "Portland Public School District"
 },
 {
   "units": "4PNG",
   "district": "Portland Public School District"
 },
 {
   "units": "5ENG",
   "district": "Portland Public School District"
 },
 {
   "units": "5LNG",
   "district": "Portland Public School District"
 },
 {
   "units": "5PNG",
   "district": "Portland Public School District"
 },
 {
   "units": "KENG",
   "district": "Portland Public School District"
 },
 {
   "units": "KLNG",
   "district": "Portland Public School District"
 },
 {
   "units": "KPNG",
   "district": "Portland Public School District"
 },
 {
   "units": "1ENG",
   "district": "Potterville Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Potterville Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "1LNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "1PNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "2ENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "2LNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "2PNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "3ENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "3LNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "3PNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "4ENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "4LNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "4PNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "5ENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "5LNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "5PNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "KENG",
   "district": "Quincy Community School District"
 },
 {
   "units": "KLNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "KPNG",
   "district": "Quincy Community School District"
 },
 {
   "units": "MSPNG1",
   "district": "Quincy Community School District"
 },
 {
   "units": "MSPNG2",
   "district": "Quincy Community School District"
 },
 {
   "units": "MSPNG3",
   "district": "Quincy Community School District"
 },
 {
   "units": "2PNG",
   "district": "Ravena Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Ravena Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Reeths Puffer Schools"
 },
 {
   "units": "4PNG",
   "district": "Reeths Puffer Schools"
 },
 {
   "units": "4LNG",
   "district": "Reformed Heritage Christian School"
 },
 {
   "units": "1ENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "1LNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "1PNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "2ENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "2LNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "2PNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "3ENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "3LNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "3PNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "4ENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "4LNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "4PNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "5ENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "5LNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "5PNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "KENG",
   "district": "Rochester Community School District"
 },
 {
   "units": "KLNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "KPNG",
   "district": "Rochester Community School District"
 },
 {
   "units": "1ENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "KENG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Rockford Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Royal Oak Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "KENG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Rudyard Area Schools"
 },
 {
   "units": "1ENG",
   "district": "Saginaw Isd"
 },
 {
   "units": "1LNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "1PNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "2ENG",
   "district": "Saginaw Isd"
 },
 {
   "units": "2LNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "2PNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "3ENG",
   "district": "Saginaw Isd"
 },
 {
   "units": "3LNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "3PNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "4ENG",
   "district": "Saginaw Isd"
 },
 {
   "units": "4LNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "4PNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "5ENG",
   "district": "Saginaw Isd"
 },
 {
   "units": "5LNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "5PNG",
   "district": "Saginaw Isd"
 },
 {
   "units": "1ENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "KENG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Sand Creek Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "1LNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "1PNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "2ENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "2LNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "2PNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "3ENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "3LNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "3PNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "4ENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "4LNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "4PNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "5ENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "5LNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "5PNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "KENG",
   "district": "Sanilac Isd"
 },
 {
   "units": "KLNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "KPNG",
   "district": "Sanilac Isd"
 },
 {
   "units": "MSPNG1",
   "district": "Sanilac Isd"
 },
 {
   "units": "MSPNG2",
   "district": "Sanilac Isd"
 },
 {
   "units": "1ENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "KENG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Sault Ste Marie Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Schoolcraft Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "KENG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Shelby Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Shelby Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Shelby Public Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Shelby Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "2ENG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "2LNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "2PNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "3ENG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "3LNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "3PNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "4ENG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "4LNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "4PNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "5ENG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "5LNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "5PNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "KENG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "KLNG",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "MSPNG1",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "MSPNG2",
   "district": "Sodus Township School District #5"
 },
 {
   "units": "1ENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "1LNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "1PNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "2ENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "2LNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "2PNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "3ENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "3LNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "3PNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "4ENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "4LNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "4PNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "5ENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "5LNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "5PNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "KENG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "KLNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "KPNG",
   "district": "South Haven Public Schools"
 },
 {
   "units": "1ENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "1LNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "1PNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "2ENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "2LNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "2PNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "3ENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "3LNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "3PNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "4ENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "4LNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "4PNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "5ENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "5LNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "5PNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "KENG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "KLNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "KPNG",
   "district": "South Lyon Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Spring Lake Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Spring Lake Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Spring Lake Public Schools"
 },
 {
   "units": "1ENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "1PNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "2ENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "2PNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "3ENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "3PNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "4ENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "4PNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "5ENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "5PNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "KENG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "KPNG",
   "district": "St. Ignace Area Schools"
 },
 {
   "units": "1PNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "2PNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "3PNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "4PNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "5PNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "KPNG",
   "district": "St. Joseph Public Schools"
 },
 {
   "units": "1ENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "1LNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "1PNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "2ENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "2LNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "2PNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "3ENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "3LNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "3PNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "4ENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "4LNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "4PNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "5ENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "5LNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "5PNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "KENG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "KLNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "KPNG",
   "district": "St. Joseph the Worker School"
 },
 {
   "units": "3PNG",
   "district": "St. Louis Public Schools"
 },
 {
   "units": "4PNG",
   "district": "St. Louis Public Schools"
 },
 {
   "units": "5PNG",
   "district": "St. Louis Public Schools"
 },
 {
   "units": "KENG",
   "district": "St. Matthew Lutheran"
 },
 {
   "units": "KLNG",
   "district": "St. Matthew Lutheran"
 },
 {
   "units": "2PNG",
   "district": "St. Michael"
 },
 {
   "units": "3ENG",
   "district": "St. Michael"
 },
 {
   "units": "3LNG",
   "district": "St. Michael"
 },
 {
   "units": "3PNG",
   "district": "St. Michael"
 },
 {
   "units": "4LNG",
   "district": "St. Michael"
 },
 {
   "units": "5LNG",
   "district": "St. Michael"
 },
 {
   "units": "5PNG",
   "district": "St. Michael"
 },
 {
   "units": "KENG",
   "district": "St. Michael"
 },
 {
   "units": "KLNG",
   "district": "St. Michael"
 },
 {
   "units": "KPNG",
   "district": "St. Michael"
 },
 {
   "units": "1ENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "1LNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "1PNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "2ENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "2LNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "2PNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "3ENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "3LNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "3PNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "4ENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "4LNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "4PNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "5ENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "5LNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "5PNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "KENG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "KLNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "KPNG",
   "district": "St. Patrick Catholic School - Parnell"
 },
 {
   "units": "1ENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "1PNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "2ENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "2PNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "3ENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "3PNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "4ENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "4PNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "5ENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "5PNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "KENG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "KPNG",
   "district": "St. Patrick Catholic School - Portland"
 },
 {
   "units": "1PNG",
   "district": "St. Thomas School"
 },
 {
   "units": "2PNG",
   "district": "St. Thomas School"
 },
 {
   "units": "3PNG",
   "district": "St. Thomas School"
 },
 {
   "units": "4PNG",
   "district": "St. Thomas School"
 },
 {
   "units": "5PNG",
   "district": "St. Thomas School"
 },
 {
   "units": "KPNG",
   "district": "St. Thomas School"
 },
 {
   "units": "1PNG",
   "district": "Summerfield School District"
 },
 {
   "units": "2ENG",
   "district": "Summerfield School District"
 },
 {
   "units": "3ENG",
   "district": "Summerfield School District"
 },
 {
   "units": "4ENG",
   "district": "Summerfield School District"
 },
 {
   "units": "5ENG",
   "district": "Summerfield School District"
 },
 {
   "units": "KPNG",
   "district": "Summerfield School District"
 },
 {
   "units": "1ENG",
   "district": "Summit Academy"
 },
 {
   "units": "1LNG",
   "district": "Summit Academy"
 },
 {
   "units": "1PNG",
   "district": "Summit Academy"
 },
 {
   "units": "2ENG",
   "district": "Summit Academy"
 },
 {
   "units": "2LNG",
   "district": "Summit Academy"
 },
 {
   "units": "2PNG",
   "district": "Summit Academy"
 },
 {
   "units": "3ENG",
   "district": "Summit Academy"
 },
 {
   "units": "3LNG",
   "district": "Summit Academy"
 },
 {
   "units": "3PNG",
   "district": "Summit Academy"
 },
 {
   "units": "4ENG",
   "district": "Summit Academy"
 },
 {
   "units": "4LNG",
   "district": "Summit Academy"
 },
 {
   "units": "4PNG",
   "district": "Summit Academy"
 },
 {
   "units": "5ENG",
   "district": "Summit Academy"
 },
 {
   "units": "5LNG",
   "district": "Summit Academy"
 },
 {
   "units": "5PNG",
   "district": "Summit Academy"
 },
 {
   "units": "KENG",
   "district": "Summit Academy"
 },
 {
   "units": "KLNG",
   "district": "Summit Academy"
 },
 {
   "units": "KPNG",
   "district": "Summit Academy"
 },
 {
   "units": "1ENG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Tahquamenon Area Schools"
 },
 {
   "units": "1ENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "KENG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Tekonsha Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "1PNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "2ENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "2PNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "3ENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "3PNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "4ENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "4PNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "5ENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "5PNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "KENG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "KPNG",
   "district": "Three Lakes Academy"
 },
 {
   "units": "1ENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "KENG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Three Rivers Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Trenton Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Trenton Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Trenton Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Trenton Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "1LNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "1PNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "2ENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "2LNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "2PNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "3ENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "3LNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "3PNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "4ENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "4LNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "4PNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "5ENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "5LNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "5PNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "KENG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "KLNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "KPNG",
   "district": "Tri County Area Schools"
 },
 {
   "units": "1ENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "1LNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "1PNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "2ENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "2LNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "2PNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "3ENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "3LNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "3PNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "4ENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "4LNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "4PNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "5ENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "5LNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "5PNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "KENG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "KLNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "KPNG",
   "district": "Trinity Lutheran School - St. Joseph"
 },
 {
   "units": "1ENG",
   "district": "Troy School District"
 },
 {
   "units": "1LNG",
   "district": "Troy School District"
 },
 {
   "units": "1PNG",
   "district": "Troy School District"
 },
 {
   "units": "2ENG",
   "district": "Troy School District"
 },
 {
   "units": "2LNG",
   "district": "Troy School District"
 },
 {
   "units": "2PNG",
   "district": "Troy School District"
 },
 {
   "units": "3ENG",
   "district": "Troy School District"
 },
 {
   "units": "3LNG",
   "district": "Troy School District"
 },
 {
   "units": "3PNG",
   "district": "Troy School District"
 },
 {
   "units": "4ENG",
   "district": "Troy School District"
 },
 {
   "units": "4LNG",
   "district": "Troy School District"
 },
 {
   "units": "4PNG",
   "district": "Troy School District"
 },
 {
   "units": "5ENG",
   "district": "Troy School District"
 },
 {
   "units": "5LNG",
   "district": "Troy School District"
 },
 {
   "units": "5PNG",
   "district": "Troy School District"
 },
 {
   "units": "KENG",
   "district": "Troy School District"
 },
 {
   "units": "KLNG",
   "district": "Troy School District"
 },
 {
   "units": "KPNG",
   "district": "Troy School District"
 },
 {
   "units": "MSPNG1",
   "district": "Troy School District"
 },
 {
   "units": "MSPNG2",
   "district": "Troy School District"
 },
 {
   "units": "1ENG",
   "district": "Union City Community School District"
 },
 {
   "units": "1LNG",
   "district": "Union City Community School District"
 },
 {
   "units": "1PNG",
   "district": "Union City Community School District"
 },
 {
   "units": "2ENG",
   "district": "Union City Community School District"
 },
 {
   "units": "2LNG",
   "district": "Union City Community School District"
 },
 {
   "units": "2PNG",
   "district": "Union City Community School District"
 },
 {
   "units": "3ENG",
   "district": "Union City Community School District"
 },
 {
   "units": "3LNG",
   "district": "Union City Community School District"
 },
 {
   "units": "3PNG",
   "district": "Union City Community School District"
 },
 {
   "units": "4ENG",
   "district": "Union City Community School District"
 },
 {
   "units": "4LNG",
   "district": "Union City Community School District"
 },
 {
   "units": "4PNG",
   "district": "Union City Community School District"
 },
 {
   "units": "5ENG",
   "district": "Union City Community School District"
 },
 {
   "units": "5LNG",
   "district": "Union City Community School District"
 },
 {
   "units": "5PNG",
   "district": "Union City Community School District"
 },
 {
   "units": "KENG",
   "district": "Union City Community School District"
 },
 {
   "units": "KLNG",
   "district": "Union City Community School District"
 },
 {
   "units": "KPNG",
   "district": "Union City Community School District"
 },
 {
   "units": "MSPNG1",
   "district": "Union City Community School District"
 },
 {
   "units": "1LNG",
   "district": "Utica Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Utica Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Utica Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Utica Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Utica Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "1LNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "1PNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "2ENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "2LNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "2PNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "3ENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "3LNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "3PNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "4ENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "4LNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "4PNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "5ENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "5LNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "5PNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "KENG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "KLNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "KPNG",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "MSENG1",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "MSPNG3",
   "district": "Van Buren Pub Schools"
 },
 {
   "units": "1ENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "2LNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "3LNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "4LNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "KENG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "KLNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Vicksburg Community Schools"
 },
 {
   "units": "1ENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "1LNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "1PNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "2ENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "2LNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "2PNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "3ENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "3LNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "3PNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "4ENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "4LNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "4PNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "5ENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "5LNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "5PNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "KENG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "KLNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "KPNG",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "MSPNG1",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "MSPNG2",
   "district": "Walkerville Public Schools"
 },
 {
   "units": "1ENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "1LNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "1PNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "2ENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "2LNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "2PNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "3ENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "3LNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "3PNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "4ENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "4LNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "4PNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "5ENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "5LNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "5PNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "KENG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "KLNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "KPNG",
   "district": "Warren Consolidated Schools"
 },
 {
   "units": "1ENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "1LNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "1PNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "2ENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "2PNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "3ENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "3PNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "4ENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "4PNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "5ENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "5LNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "5PNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "KENG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "KPNG",
   "district": "Webberville Community Schools"
 },
 {
   "units": "1PNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "2PNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "3PNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "4PNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "5ENG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "5PNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "KPNG",
   "district": "West Michigan Academy of Arts & Academics"
 },
 {
   "units": "1ENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "1LNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "1PNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "2ENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "2LNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "2PNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "3ENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "3LNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "3PNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "4ENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "4LNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "4PNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "5ENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "5LNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "5PNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "KENG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "KLNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "KPNG",
   "district": "West Shore Educational Service Dist."
 },
 {
   "units": "5LNG",
   "district": "Western Michigan Christian School"
 },
 {
   "units": "5PNG",
   "district": "Western Michigan Christian School"
 },
 {
   "units": "1ENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "1LNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "1PNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "2ENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "2LNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "2PNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "3ENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "3LNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "3PNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "4ENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "4LNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "4PNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "5ENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "5LNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "5PNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "KENG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "KLNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "KPNG",
   "district": "Woodland Park Academy"
 },
 {
   "units": "1ENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "1LNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "1PNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "2ENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "2LNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "2PNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "3ENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "3LNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "3PNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "4ENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "4LNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "4PNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "5ENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "5LNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "5PNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "KENG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "KLNG",
   "district": "Zion Lutheran School"
 },
 {
   "units": "KPNG",
   "district": "Zion Lutheran School"
 }
]
    }
  },
  methods: {
    batchUpdateUnits() {
      this.districtUnits.forEach((unit) => {
        fb.districtsCollection.where("districtName", "==", unit.district).get().then((snap) => {
          snap.forEach((doc) => {
            this.distUid = doc.id
            console.log(this.distUid)
          })
        }).then(() => {
          fb.districtsCollection.doc(this.distUid).update({
            "units": fieldValue.arrayUnion(unit.units)
          }).then(() => {
            console.log(unit.district, ' was updated')
          }).catch((err) => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
